export const menuManagementData = [
  {
    key: "1",
    MENU: "Header Top",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Published",
  },
  {
    key: "2",
    MENU: "Footer 1",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Unpublished",
  },
  {
    key: "3",
    MENU: "Footer 2",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Published",
  },
  {
    key: "4",
    MENU: "Footer 3",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Published",
  },
  {
    key: "5",
    MENU: "Footer 4",
    CREATEDDATE: "24 Jan 2025",
    STATUS: "Published",
  },
];
